<a [routerLink]="user && user.username ? ['/a', user.username] : ['#']">
  <img class="w-full border rounded-full object-cover cursor-pointer" [src]="user | avatarSize: size"
    [alt]="user && user.username ? user.username : 'default-avatar'" width="80" height="80" />
</a>